import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core'
import { Router, ActivatedRoute, Params } from '@angular/router';

import { sla, kpiRelease, kpiReset, quater, year, kpi, kpiInbox, kpiViewComment, kpiViewWorkFlow, kpiband, performanceDashBoard, slakpiperformance } from './../../../../models/slakpi';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';

import { division, tenant } from './../../../../models/admin';
import { UtilityService } from './../../../../services/utility.service';
import { SLAKPIApiService } from './../../../../services/slakpi.service';
import { AdminApiService } from './../../../../services/admin.service';
import { UserService } from './../../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2';
import { GoogleChartComponent } from 'ng2-google-charts';
declare var jquery: any;
declare var $: any;
declare var google: any;
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { KPIAllHistoryComponent } from './../../../../component/slakpi/kpi-allhistory/kpi-allhistory.component';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  OnEventArgs,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../../toaster.service';
import { RSAHelper } from '../../../../models/RSAHelper';


@Component({
  selector: 'app-sla-kpi.component',
  templateUrl: './slakpi.component.html',
  styleUrls: ['./slakpi.component.css']

})
export class SLAKPIComponent implements OnInit { 
  SlaChartOption: any = {};
  welformedchartOption: any = {};
  public sli_data: any;
  public chartType: string = '';
  public kpiInbox_data: any;
  public kpiInbox_data_count: any;
  public kpiViewComment_data: any;
  public kpiViewIssue_data: any;
  public kpiViewJustification_data: any;
  public filter_data: any;
  public yearData: any;
  public quaterData: any;
  public chartType_data: any;
  public chartValue: string = 'Quarter';
  public division_data: any=[];
  public frequency_data: any;
  public resettype_data: any;
  public resetComment: string = '';
  public resetType_txt: string = '';
  public slaUno?: number;
  public yearUno?: number;
  public quarterUno?: number;
  public divisionUno?: number;
  public frequencyUno?: number;
  public selectedTab?: string = 'Release';
  public objkpiInbox_selecteddata: kpiViewWorkFlow;
  public kpiRuleForm: FormGroup;
  public kpiCodeDetail: kpiInbox;
  public objkpiRelease: kpiReset;
  public NANRVal: string = '';
  public band_calculated: string = '';
  public kpiTrnUno: number = 0;
  public kpiViewBand_data: any;
  public actualTargetValue: number;
  public position_dataentry: object = { X: 390, Y: 120 };
  public position_band: object = { X: 600, Y: 340 };
  public position_comment: object = { X: 120, Y: 150 };
  public position_appreject: object = { X: 450, Y: 240 };
  public position_history: object = { X: 70, Y: 100 };
  public position_chart: object = { X: 150, Y: 150 };
  public isResetType: boolean = true;
  public pageSettings_Justfication: Object;
  public toolbar_Justfication: Object;
  @ViewChild('BandDialog', { static: false }) BandDialog: TemplateRef<any>;
  public actualTrend: string = '';

  public loadedChartVal: any;
  public ChartinpType: string = 'y';
  public chartTypedata: any;
  enableHisGrid: boolean = false;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;

  gridOptionsHistory: GridOption;
  columnCommentDefinitions: Column[];
  cmtsGrid: AngularGridInstance;
  datasetComments: any;
  issueGrid: AngularGridInstance;
  datasetIssues: any;
  columnIssueDefinitions: Column[];
  modalRef: BsModalRef;
  @ViewChild('CommentDialog', { static: false }) CommentDialog: TemplateRef<any>;
  @ViewChild('KPIDataEntryDialog', { static: false }) KPIDataEntryDialog: TemplateRef<any>;
  @ViewChild('ResetDialog', { static: false }) ResetDialog: TemplateRef<any>;

  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public formatoptions: Object;
  isToggle: boolean = true;

  public commentStartIndex: number = 1;
  public commentMaxCount: number = 15;
  public disableMore: boolean = true;
  public checkboxDisable: boolean = true;
  public isStart: boolean = true;
  public onApproveTabSelected: boolean = true;
  //for KPI All Hisory Dialog
  public kpiUnoSelected: number = 0;
  public yearUno_chart: number = 0;
  public quaterUno_chart: number = 0;
  public kpinameSelected: string = '';
  @ViewChild('KPIAllHistoryDialog', { static: false }) KPIAllHistoryDialog: TemplateRef<any>;
  @ViewChild('KPIChartDialog', { static: false }) KPIChartDialog: TemplateRef<any>;


  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  approveComment?: string = '';
  rejectComment?: string = '';
  isAdmin: boolean = false;
  isKpichartload: boolean = true;
  isRowSelected: boolean = false;
  public scrollSettings: any;
  public currentLevelUser: string = '';
  public currentLevel: number;
  public isCurrentLevelUser: boolean = false;

  public filterDataCollection: number = 0;
  public filterOverdue: number = 0;
  public filterCompleted: number = 1;
  public filterApproval: number = 0;
  public filterColor: string = '';

  public filterAll_classactive: string = 'active';
  public filterDataCollection_classactive: string = '';
  public filterOverdue_classactive: string = '';
  public filterCompleted_classactive: string = 'active';
  public filterApproval_classactive: string = '';

  public filterDataCollectionCount: number = 0;
  public filterOverdueCount: number = 0;
  public filterCompletedCount: number = 0;
  public filterApprovalCount: number = 0;
  public filterAllCount: number = 0;

  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  public tenantUno?: number;

  public isResetTypeErr: boolean = false;
  public isCommentErr: boolean = false;

  //chart
  //Initializing Primary X Axis
  public primaryXAxis: Object = {
    valueType: 'Category'
  };
  public primaryYAxis: Object = {
    title: 'Value',
    majorTickLines: { width: 0 }, majorGridLines: { width: 1 },
    minorGridLines: { width: 1 }, minorTickLines: { width: 0 }
  };

  public titlechart = 'KPI Chart';
  public zoomSettings: Object = {
    mode: 'X',
    enableMouseWheelZooming: true,
    enablePinchZooming: true,
    enableSelectionZooming: true,
    enableScrollbar: true
  };
  public marker: Object;
  public tooltip: Object;
  public palette: string[];
  public ChartKPIdatamain: any;
    searchText: string;
    dataSearch: any;
  noDataImg: any;
  isDigitalDewa: boolean = false;

  wellPerformedKPICount: number = 0;
  underPerformedKPICount: number = 0;
  PerformanceDashboard_data: any;
  reportedKPICount: number = 0;
  noOfNAKPICount: number = 0;
  KPICount: number = 0;
  totalKPIWPPercentage: number = 0;
  reporting: number = 0;

  slakpiPerformanceFilter: any = {};
    wellperformKPIRange: any;

  isSingleClick: boolean = true;
  g_previousIndex: any;

  slaName: string = '';
  divisionPlaceholder: string = 'Division';

  strDivisionLegend: string = "DEWA";
    isDivision: number=1;
  constructor(public restApi: SLAKPIApiService, private _activatedRoute: ActivatedRoute, private toaster: ToasterService, private modalService: BsModalService, public adminService: AdminApiService, public utilityService: UtilityService,
    private spinner: SpinnerVisibilityService, private router: Router, private userService: UserService,
    private kpiAllHistoryComponent: KPIAllHistoryComponent, public RASHelper: RSAHelper) {
    
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    this.isDigitalDewa = (this.user.tenantDigitalUser == 'true') ? true : false;
    if (!this.isAdmin) {
      this.CheckUserPermission();
    }
    else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;
      //User rights
      // this.toolbar = this.userService.getRights_Toolbar(this.permision_add, this.permision_edit, this.permision_delete);
      this.toolbar = ['Search', 'ExcelExport'];
      this.toolbar_Justfication = ['Search'];
      this.pageSettings_Justfication = { pageSize: 15, pageSizes: true };
      this.tooltip = { enable: true };
      this.marker = {
        visible: true, width: 10, height: 10, dataLabel: { visible: true }, border: { width: 2, color: 'red' },
        rx: 10, ry: 10
      };
      this.palette = ["#07682d", "#e34867", "#6FAAB0", "#C4C24A"];

    }

    //Load Default Values
    this._activatedRoute.params.subscribe((params: Params) => {
      
      if (params['pagetype'] != null && params['pagetype'] == 'approval') {
        this.filterApproval_classactive = 'active';
        // this.filterApproval = 1; this.onfilterData('approval', '');
      } else if (params['pagetype'] != null && params['pagetype'] == 'completed') {
        this.filterCompleted_classactive = 'active';

        // this.filterCompleted = 1; this.onfilterData('completed', '');
      } else if (params['pagetype'] != null && params['pagetype'] == 'dataentry') {
        this.filterDataCollection_classactive = 'active';
        //  this.filterDataCollection = 1;
        // this.onfilterData('data', '');
      }
      else {
        this.filterApproval_classactive = 'active';
        // this.filterApproval = 1;
      }
      this.filterCompleted_classactive = 'active';
      this.filterDataCollection = 0;
      this.filterOverdue = 0;
      this.filterApproval = 0;
      this.filterCompleted = 0;
      //this.loadKPIInbox();
      //this.loadKPIInboxCount();
      this.loadResetType();
    });


  }
  

  ngOnInit() {
   
      this.userService.CheckLogin();

    this.user = this.userService.getUserInfo();
    this.slakpiPerformanceFilter = this.userService.getSLAKPIFilterInfo();
    this.login_UserID = this.user.id;
    this.wellperformKPIRange = this.user.wellperformKPIRange;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    if (!this.isAdmin) {
      this.router.navigateByUrl('/access-denied/');
    }

    this.slaName = this.user.slaname;
    if (this.tenantUno > 1) {
      this.divisionPlaceholder = "Select";
      this.strDivisionLegend = "";
    }

    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 100
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,
      enableCheckboxSelector: false,

      multiSelect: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true,
      },

    };

    this.gridOptionsHistory = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,

      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'myTabContent',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };

    this.currentYear = this.user.currentYear;
    this.currentHalf = this.user.currentHalf;
    this.currentQuarter = this.user.currentQuarter;
    this.currentMonth = this.user.currentMonth;
    this.objkpiInbox_selecteddata = new kpiViewWorkFlow();
    this.kpiCodeDetail = new kpiInbox();
    this.yearUno = Number(this.currentYear);
    this.quarterUno = Number(this.currentQuarter);
    this.filterApproval_classactive = 'active';
    // this.filterApproval = 1;
    this.scrollSettings = { width: 550, height: 300, frozenColumns: 2 };
    //this.loadSLA();
    //this.loadYear();
    //this.loadQuater();
    //this.loadDivisions();
    //this.loadFrequency();
    this.getTenantInfo();
    this.loadFrequency();
    this.loadFilterValues();
    //this.loadPerformanceDashBoard();
    this.getChartType();
    this.getChartTypeData();
    //this.toolbar = ['Search', 'ExcelExport'];

    this.pageSettings = { pageSize: 20, pageSizes: true };
    this.filterSettings = { type: 'Excel' };
    this.formatoptions = { type: 'date', format: 'dd/MM/yyyy' };
    // this.KPIAllHistoryDialog.hide();

    this.kpiRuleForm = new FormGroup({
      justification: new FormControl(),
      enteredTargetValue: new FormControl(),
      selectNANR: new FormControl(),
      selectPassFail: new FormControl()
    });
    this.getFilter();
  }
  //To Validate Current User - Page Level Permission
  CheckUserPermission() {

    //let userPermissionData = this.userService.getUserRights("Admin KPI");
    //if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
    //  if (userPermissionData[0].showPage == 1) {
    //    this.permision_add = (userPermissionData[0].showAdd == 1) ? true : false;
    //    this.permision_edit = (userPermissionData[0].showEdit == 1) ? true : false;
    //    this.permision_delete = (userPermissionData[0].showDelete == 1) ? true : false;
    //    
    //    //User rights
    //    //this.editSettings = { allowEditing: this.permision_edit, allowAdding: this.permision_add, allowDeleting: this.permision_delete, mode: 'Dialog' };

    //    this.toolbar = this.userService.getRights_Toolbar(this.permision_add, this.permision_edit, this.permision_delete);

    //  }
    //  else {
    //    this.router.navigateByUrl('/access-denied');
    //  }
    //}
    //else {
    //  this.router.navigateByUrl('/access-denied');
    //}

    this.permision_add = true;
    this.permision_edit = true;
    this.permision_delete = true;
  }
  getFilter() {
    this.filter_data = [
      { value: 'data', text: 'Data Collection' },
      { value: 'approval', text: 'Approvals' },
      { value: 'completed', text: 'Completed' },
    ];
  }

  getChartTypeData() {
    if (this.tenantUno > 1) {
      this.chartType_data = [
        { value: 'Quarter', text: 'Quarter' },
        { value: 'Year', text: 'Year' },
        { value: 'Month', text: 'Month' }
      ];
    }
    else {
      this.chartType_data = [
        { value: 'Quarter', text: 'Quarter' },
        { value: 'Year', text: 'Year' }
      ];
    }
  }

  // Get sla list
  loadSLA() {
    this.spinner.show();
    let inpValue = new sla();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getSLAs(inpValue)
      .subscribe(data => {
        
        this.sli_data = data;
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  // Get Year / Quater
  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getYearMaster(inpValue)
      .subscribe(data => {
        
        this.yearData = data;
        //this.inpyeardata.addItem({ text: 'All', value: '0' }, 0);
        setTimeout(() => {
          
          this.yearUno = Number(this.yearUno);
        }, 10);

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  loadQuater() {

    let inpValue = new quater();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getQuaterMaster(inpValue)
      .subscribe(data => {
        
        this.quaterData = data;
        //setTimeout(() => {
        //  
        //  this.inpquaterdata.value = Number(this.quarterUno);

        //}, 10);


      },
        (error) => {
          //Called when error
          this.loadKPIInbox();
          //this.loadKPIInboxCount();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  

  loadFrequency() {
    
    if (this.isDigitalDewa == false) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' }
        //{ frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }

    if (this.isDigitalDewa == true || this.tenantUno == 5) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' },
        { frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }
  }

  //Load Frequency Values
  loadFilterValues() {
    this.spinner.show();
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.isStart = true;
    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {

        let objdata: any = data;
        this.sli_data = objdata.list_SLAMaster;
        this.division_data = objdata.list_DivisionMaster;
        this.quaterData = objdata.list_QuarterMaster;
        this.yearData = objdata.list_YearMaster;
        //this.quarterUno = Number(this.yearUno);

        //if (this.division_data != null && this.division_data.length == 1) {
        //  this.divisionUno = this.division_data[0].divisionUno;
        //}
        setTimeout(() => {
          //this.quarterUno = Number(objdata.list_QuarterMaster[0].value);
          //Load Inbox default value

          if (this.slakpiPerformanceFilter != undefined) {
            this.slaUno = parseInt(this.slakpiPerformanceFilter.slaUno);
            this.yearUno = parseInt(this.slakpiPerformanceFilter.yearUno);
            this.quarterUno = parseInt(this.slakpiPerformanceFilter.quarterUno);
            this.divisionUno = parseInt(this.slakpiPerformanceFilter.divisionUno);
            this.frequencyUno = parseInt(this.slakpiPerformanceFilter.frequencyUno);

          }

          this.loadKPIInbox();
          this.loadPerformanceDashBoard();
          //this.loadKPIInboxCount();

        }, 230);

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

  // Get kpi inbox list
  //loadKPIInbox() {
  //  
  //  this.loading = true;
  //  this.spinner.show();
  //  let inpValue = new kpiInbox();
  //  inpValue.languageUno = 1033;
  //  inpValue.itemUno = 0;
  //  inpValue.condition = 2;
  //  inpValue.tenantUno = this.tenantUno;
  //  inpValue.userUno = this.login_UserID;
  //  //inpValue.slaUno = this.slaUno;
  //  //inpValue.slaRuleUno = this.frequencyUno;
  //  //inpValue.reportingDivisionUno = this.divisionUno;

  //  inpValue.slaUno = (this.slaUno == 0 || this.slaUno == undefined) ? 0 : this.slaUno;
  //  inpValue.currentYear = (this.yearUno == 0 || this.yearUno == undefined) ? 0 : this.yearUno;
  //  inpValue.currentQuarter = (this.quarterUno == 0 || this.quarterUno == undefined) ? 0 : this.quarterUno;
  //  inpValue.reportingDivisionUno = (this.divisionUno == 0 || this.divisionUno == undefined) ? 0 : this.divisionUno;
  //  inpValue.slaRuleUno = (this.frequencyUno == 0 || this.frequencyUno == undefined) ? 0 : this.frequencyUno;

  //  //inpValue.currentYear = this.currentYear;
  //  //inpValue.currentQuarter = this.currentQuarter;
  //  inpValue.currentMonth = 0;
  //  inpValue.currentHalf = 0;
  //  inpValue.filterDataCollection = 0;
  //  inpValue.filterOverdue = 0;
  //  inpValue.filterApproval = 0;
  //  inpValue.filterCompleted = 0;
  //  inpValue.filterColor = this.filterColor;
  //  inpValue.isAdmin = this.isAdmin;

  //  this.restApi.getKpiInbox(inpValue)
  //    .subscribe(data => {
  //      
  //      this.spinner.show();
  //      let rtnData: any = data;
  //      this.kpiInbox_data = rtnData.data;
  //      const mockDataset = [];
  //      //for (let i = 0; i < this.kpiInbox_data.length; i++) {
  //      //  mockDataset[i] = {
  //      //    id: i + 1,
            
  //      //    kpiCode: this.kpiInbox_data[i].kpiCode,
  //      //    kpiNameEn: this.kpiInbox_data[i].kpiNameEn,
  //      //    slaName: this.kpiInbox_data[i].slaName,
  //      //    periodDisplay: this.kpiInbox_data[i].periodDisplay,
  //      //    slaRuleName: this.kpiInbox_data[i].slaRuleName,
  //      //    targetValueText: this.kpiInbox_data[i].targetValueText,
  //      //    slaRuleUno: this.kpiInbox_data[i].slaRuleUno,
  //      //    dataOwnerActionBy: this.kpiInbox_data[i].dataOwnerActionBy,
  //      //    targetValue: this.kpiInbox_data[i].targetValue,
  //      //    bandValueText: this.kpiInbox_data[i].bandValueText,
  //      //    bandValue: this.kpiInbox_data[i].bandValue,
  //      //    bandColour: this.kpiInbox_data[i].bandColour,
  //      //    kpiUno: this.kpiInbox_data[i].kpiUno,
  //      //    isNANRNT: this.kpiInbox_data[i].isNANRNT,
  //      //    dataOwnerExists: this.kpiInbox_data[i].dataOwnerExists,
  //      //    actualValueText: this.kpiInbox_data[i].actualValueText,
  //      //    actualTargetValue: this.kpiInbox_data[i].actualTargetValue,
  //      //    currentStage: this.kpiInbox_data[i].currentStage,
  //      //    kpiTrnUno: this.kpiInbox_data[i].kpiTrnUno,
  //      //    approver1Exists: this.kpiInbox_data[i].approver1Exists,
  //      //    approver2Exists: this.kpiInbox_data[i].approver2Exists,
  //      //    approver3Exists: this.kpiInbox_data[i].approver3Exists,
  //      //    commentCount: this.kpiInbox_data[i].commentCount,
  //      //    dataOwnerActionByUno: this.kpiInbox_data[i].dataOwnerActionByUno,
  //      //    level1ApprovedBy: this.kpiInbox_data[i].level1ApprovedBy,
  //      //    level2ApprovedBy: this.kpiInbox_data[i].level2ApprovedBy,
  //      //    level3ApprovedBy: this.kpiInbox_data[i].level3ApprovedBy,
  //      //    level1Approved: this.kpiInbox_data[i].level1Approved,
  //      //    level2Approved: this.kpiInbox_data[i].level2Approved,
  //      //    level3Approved: this.kpiInbox_data[i].level3Approved,
  //      //    level1ApproverUno: this.kpiInbox_data[i].level1ApproverUno,
  //      //    level2ApproverUno: this.kpiInbox_data[i].level2ApproverUno,
  //      //    level3ApproverUno: this.kpiInbox_data[i].level3ApproverUno,
  //      //    dataOwnerUno: this.kpiInbox_data[i].dataOwnerUno,
  //      //    kpiYearName: this.kpiInbox_data[i].kpiYearName,
  //      //    kpiQuarterName: this.kpiInbox_data[i].kpiQuarterName,
  //      //    scheduleText: this.kpiInbox_data[i].scheduleText,
  //      //    scheduleUno: this.kpiInbox_data[i].scheduleUno,
  //      //    statusUno: this.kpiInbox_data[i].statusUno,
  //      //  };
  //      //}
  //      this.dataset = this.kpiInbox_data;//mockDataset;
  //      this.dataSearch = this.kpiInbox_data;//mockDataset;
  //      if (this.kpiInbox_data.length > 0) {
  //        this.setColnDefn();
  //      }
        

  //     // this.isStart = false;
  //      setTimeout(() => {
  //        this.loading = false;
  //        this.spinner.hide();
  //      }, 1500);
  //      //setTimeout(() => { this.groupOptions = { columns: ['kpiNameEn'] }; }, 100);
  //    },
  //      (error) => {
  //        //Called when error
  //        this.spinner.hide();
  //        this.isStart = false;
  //      }
  //    ).add(() => {
  //      //Called when operation is complete (both success and error)
  //      //  this.spinner.hide();
  //      //this.isStart = false;
  //    });
  //}
  loadKPIInbox() {
    
    this.loading = true;
    this.spinner.show();
    let inpValue = new slakpiperformance();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 3;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.slaUno = (this.slaUno == 0 || this.slaUno == undefined) ? 0 : this.slaUno;
    inpValue.kpiyear = (this.yearUno == 0 || this.yearUno == undefined) ? this.currentYear : this.yearUno;
    inpValue.kpiyearTo = inpValue.kpiyear.toString();
    inpValue.kpiquarter = (this.quarterUno == 0 || this.quarterUno == undefined) ? this.currentQuarter : this.quarterUno;
    inpValue.divisionUno = (this.divisionUno == 0 || this.divisionUno == undefined) ? 0 : this.divisionUno;
    inpValue.frequencyUno = (this.frequencyUno == 0 || this.frequencyUno == undefined) ? 0 : this.frequencyUno;
    inpValue.half = this.currentHalf;
    inpValue.month = this.currentMonth;
    inpValue.wellperformKPIRange = this.wellperformKPIRange;
    this.restApi.getSlaKpiPerformance(inpValue)

      .subscribe(data => {
        let rtnData: any = data;
        this.kpiInbox_data = rtnData;
        //this.kpiInbox_data = rtnData.data;
        //const mockDataset = [];
        //for (let i = 0; i < this.kpiInbox_data.length; i++) {
        //  mockDataset[i] = {
        //    id: i + 1,
        //    kpiTrnUno: this.kpiInbox_data[i].kpiTrnUno,
        //    kpiCode: this.kpiInbox_data[i].kpiCode,
        //    kpiName: this.kpiInbox_data[i].kpiName,
        //    divisionName: this.kpiInbox_data[i].divisionName,
        //    year: this.kpiInbox_data[i].year,
        //    quarter: this.kpiInbox_data[i].quarter,
        //    periodDisplay: this.kpiInbox_data[i].periodDisplay,
        //    type: this.kpiInbox_data[i].type,
        //    actualValueText: this.kpiInbox_data[i].actualValueText,
        //    targetValueText: this.kpiInbox_data[i].targetValueText,
        //    kpiRule: this.kpiInbox_data[i].kpiRule,
        //    bandValueText: this.kpiInbox_data[i].bandValueText,
        //    bandValue: this.kpiInbox_data[i].bandValue,
        //    slaRuleUno: this.kpiInbox_data[i].slaRuleUno,
        //    scheduleName: this.kpiInbox_data[i].scheduleName,
        //    kpiUno: this.kpiInbox_data[i].kpiUno,
        //    isNANRNT: this.kpiInbox_data[i].isNANRNT,
        //    actualValue: this.kpiInbox_data[i].actualValue,
        //  };
        //}
        //this.dataset = mockDataset;
        //this.dataSearch = mockDataset;
        //if (mockDataset.length > 0) {
        //  this.setColnDefn();
        //}

        this.dataset = this.kpiInbox_data;//mockDataset;
        this.dataSearch = this.kpiInbox_data;//mockDataset;
        if (this.kpiInbox_data.length > 0) {
          this.setColnDefn();
        }
        this.loading = false;

        //this.isStart = false;
        //setTimeout(() => { this.spinner.hide(); }, 1500);
        //setTimeout(() => { this.groupOptions = { columns: ['kpiNameEn'] }; }, 100);
      },
        (error) => {
          //Called when error
          this.loading = false;
          //this.spinner.hide();
          this.isStart = false;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //  this.spinner.hide();
        //this.isStart = false;
      });
  }
 


  viewKPI(kpiTrnUno: any) {
    
    this.router.navigateByUrl('/kpiview/' + kpiTrnUno);
  }

  viewKPIComment(kpiTrnUno: any) {
    
    this.kpiViewComment_data = [];
    this.kpiViewIssue_data = [];
    this.kpiViewJustification_data = [];

    this.spinner.show();
    let inpValue = new kpiViewComment();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.commentStartIndex = (this.commentStartIndex == undefined || this.commentStartIndex < 1) ? 1 : this.commentStartIndex;
    inpValue.startIndex = this.commentStartIndex;
    inpValue.maxCount = this.commentMaxCount;

    this.restApi.getKpiViewComments(inpValue)
      .subscribe(data => {

        let objData: any = data;
        if (this.commentStartIndex == 1) {
          this.kpiViewComment_data = [];
          this.kpiViewComment_data = objData;

        }
        else {
          for (var i = 0; i < objData.length; i++) {
            this.kpiViewComment_data.push(objData[i]);
          }
        }
        //if the result set is lessthen 10 then disable the load more icon
        this.disableMore = (objData.length >= 15) ? false : true;
        if (objData.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.commentStartIndex = this.commentStartIndex + 1;
        }

        this.viewKPIIssue(kpiTrnUno);
        this.viewKPIJustification(kpiTrnUno);

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  viewKPIIssue(kpiTrnUno: any) {
    
    this.spinner.show();
    let inpValue = new kpiViewComment();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.commentStartIndex = (this.commentStartIndex == undefined || this.commentStartIndex < 1) ? 1 : this.commentStartIndex;
    inpValue.startIndex = this.commentStartIndex;
    inpValue.maxCount = this.commentMaxCount;

    this.restApi.getKpiViewIssue(inpValue)
      .subscribe(data => {

        if (data != null && data != undefined) {
          this.kpiViewIssue_data = data;
          const mockDataset = [];
          for (let i = 0; i < this.kpiViewIssue_data.length; i++) {
            mockDataset[i] = {
              id: i + 1,
              postedBy: this.kpiViewIssue_data[i].postedBy,
              postedDate: this.kpiViewIssue_data[i].postedDate,
              comment: this.kpiViewIssue_data[i].comment,
            };
          }
          this.datasetIssues = mockDataset;
        }
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  viewKPIJustification(kpiTrnUno: any) {
    
    this.spinner.show();
    let inpValue = new kpiViewComment();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.commentStartIndex = (this.commentStartIndex == undefined || this.commentStartIndex < 1) ? 1 : this.commentStartIndex;
    inpValue.startIndex = this.commentStartIndex;
    inpValue.maxCount = this.commentMaxCount;

    this.restApi.getKpiViewJustification(inpValue)
      .subscribe(data => {

        if (data != null && data != undefined) {
          this.kpiViewJustification_data = data;
          const mockDataset = [];
          for (let i = 0; i < this.kpiViewJustification_data.length; i++) {
            mockDataset[i] = {
              id: i + 1,
              action: this.kpiViewJustification_data[i].action,
              postedBy: this.kpiViewJustification_data[i].postedBy,
              postedDate: this.kpiViewJustification_data[i].postedDate,
              comment: this.kpiViewJustification_data[i].comment,
            };
          }
          this.datasetComments = mockDataset;
          this.setCommentDefn();
        }
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  showCommentDialog(kpiTrnUno: any, kpiNameEn: any) {
    this.viewKPIComment(kpiTrnUno);
    this.kpiViewComment_data = [];
    this.kpinameSelected = kpiNameEn;
    this.commentStartIndex == 1;
    this.modalRef = this.modalService.show(
      this.CommentDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }
  getMoreComment() {
    //this.viewKPIComment();
  }
  DataEntryKPI(objData: any) {
    
    this.kpiTrnUno = objData.kpiTrnUno;
    this.kpiViewBand_data = new kpiband();
    this.loadKPICodeDetails(objData.kpiTrnUno);
  }
  //Get KPI Code Details
  loadKPICodeDetails(kpiTrnUno: number) {
    
    this.spinner.show();
    let inpValue = new kpiInbox();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 2;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.NANRVal = '';
    this.restApi.getKpiCodeDetails(inpValue)
      .subscribe(data => {
        
        //this.data = data;
        if (data != null && data != undefined) {
          this.modalRef = this.modalService.show(
            this.KPIDataEntryDialog,
            Object.assign({}, {
              class: 'gray modal-lg',
              backdrop: true,
              keyboard: true,
              focus: true,
              show: false,
              ignoreBackdropClick: true,
              animated: true
            })
          );
          //this.kpiCodeDetail = new kpiInbox();
          this.kpiCodeDetail = data[0];
          if (this.kpiCodeDetail != null) {
            this.NANRVal = '';
            this.actualTargetValue = parseInt(this.kpiCodeDetail.actualValue != '' ? this.kpiCodeDetail.actualValue : '0');
            this.actualTrend = this.kpiCodeDetail.trendUno;
            this.kpiRuleForm.setValue({
              enteredTargetValue: this.kpiCodeDetail.targetValue,
              justification: this.kpiCodeDetail.dataOwnerComments,
              selectNANR: (this.kpiCodeDetail.isNANRNT == 'NA' ? true : false),
              selectPassFail: this.kpiCodeDetail.passFail
            });
            if (this.kpiCodeDetail.isNANRNT == 'NA') {
              this.kpiRuleForm.get('enteredTargetValue').reset();
              this.kpiRuleForm.get('enteredTargetValue').disable();

              this.kpiRuleForm.get('selectPassFail').reset();
              this.kpiRuleForm.get('selectPassFail').disable();
              this.NANRVal = 'NA';
              this.band_calculated = 'gray-bar';
            }
            if (this.kpiCodeDetail.bandColour != '') {
              this.band_calculated = (this.kpiCodeDetail.bandColour == 'Red') ? 'red-bar' :
                (this.kpiCodeDetail.bandColour == 'Orange') ? 'orange-bar' :
                  (this.kpiCodeDetail.bandColour == 'Yellow') ? 'yellow-bar' :
                    (this.kpiCodeDetail.bandColour == 'Light Green') ? 'light-green-bar' : (this.kpiCodeDetail.bandColour == 'Green') ? 'green-bar' : 'gray-bar';
            }
            else {
              this.band_calculated = 'gray-bar';
            }
          }
          this.loadKPIViewBand(this.kpiCodeDetail.kpiUno, this.kpiCodeDetail.kpiYear, this.kpiCodeDetail.scheduleUno, this.kpiCodeDetail.bandScheduleTypeUno);

          //this.kpiUno = data[0].kpiUno;
          //this.scheduleUno_gloabl = data[0].scheduleUno;
          //this.getSchduleTypeNo();
          //this.actualTargetValue = (this.kpiCodeDetail.actualValue != null && this.kpiCodeDetail.actualValue != '') ? parseInt(this.kpiCodeDetail.actualValue) : 0;
          //this.checkCurrentUserAndLevel(data);


        }

        this.spinner.hide();

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  //Get KPI Band
  loadKPIViewBand(kpiUno: number, defaultyear: number, scheduleUno: number, bandScheduleTypeUno: number) {

    this.spinner.show();
    let inpValue = new kpiband();
    inpValue.kpiUno = kpiUno;
    inpValue.kpiYear = defaultyear;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.scheduleUno = scheduleUno;
    inpValue.scheduleTypeUno = bandScheduleTypeUno;
    this.restApi.getkpiViewBand(inpValue)
      .subscribe(data => {
        this.kpiViewBand_data = data[0];

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  onSubmit(slaRuleUno: number, type: string) {
    


    let selectNANR = null;
    let comment = '';
    let targetEnValue = 0;
    let passfail = '';
    //Get Selected Vlaues
    selectNANR = (this.NANRVal == null || this.NANRVal == undefined) ? '' : 'NA';
    let objTargetEnValue = this.kpiRuleForm.get('enteredTargetValue').value;
    comment = 'Admin Editted the Value';//this.kpiRuleForm1.get('justification').value;

    //Set Target if Rule is text [Pass--100 / Fail --0]
    if (slaRuleUno == 4) {
      passfail = (this.kpiRuleForm.get('selectPassFail') != null) ? this.kpiRuleForm.get('selectPassFail').value : '';
    }

    //Target Value validation
    targetEnValue = (objTargetEnValue != '' && objTargetEnValue != null) ? parseInt(objTargetEnValue) : 0;
    //if ((this.txtTarget.value == null || this.txtTarget.value.toString() == '' || objTargetEnValue == null || objTargetEnValue == '') && selectNANR == '') {
    if (targetEnValue == 0 && selectNANR == '' && (slaRuleUno == 1 || slaRuleUno == 2)) {
      //Swal.fire('Error', 'Please Enter the Target Value', 'error');
      this.toaster.show('error', 'Error', 'Please Enter the Target Value');
      return false;
    }



    //Comment require
    
    if (this.NANRVal != '' || passfail == 'Fail') {
      // let comment = this.kpiRuleForm.get('comment').value;
      if (comment == '' || comment == null) {
        //Swal.fire('Error', 'Please Enter the Justification', 'error')
        this.toaster.show('error', 'Error', 'Please Enter the Justification');
        return false;
      }
    }

    let objKPIView = new kpiViewWorkFlow();
    objKPIView.action = 'send for Approval by Data Owner';
    objKPIView.selectedNANR = this.NANRVal;
    objKPIView.kpiTrnUno = this.kpiTrnUno;
    objKPIView.comment = (comment == null || comment == undefined) ? '' : comment;
    objKPIView.userUno = this.login_UserID;

    objKPIView.passFail = passfail;
    objKPIView.targetEnteredValue = targetEnValue;
    objKPIView.condition = 0;//(this.pageAction == "add") ? 0 : 1;
    objKPIView.saveAction = type;
    

    if (slaRuleUno == 1 || slaRuleUno == 2 || slaRuleUno == 3) {


      let classname: string = '';
      let band1Value1 = this.kpiViewBand_data.band1Value1;
      let band2Value1 = this.kpiViewBand_data.band2Value1;
      let band3Value1 = this.kpiViewBand_data.band3Value1;
      let band4Value1 = this.kpiViewBand_data.band4Value1;
      let band5Value1 = this.kpiViewBand_data.band5Value1;
      let band1Condition1 = this.kpiViewBand_data.band1Condition1;
      let band2Condition1 = this.kpiViewBand_data.band2Condition1;

      if (targetEnValue > this.actualTargetValue) {
      //  Swal.fire('Error', ' Target Value should <=' + this.actualTargetValue, 'error')
        this.toaster.show('error', 'Error', ' Target Value should <=' + this.actualTargetValue);
        classname = '';
        return false;
      }
      let bandfinalcolor = '';
      if (this.NANRVal == '') {
        classname = this.getBadcolorFinal(slaRuleUno, targetEnValue, band1Value1, band2Value1, band3Value1, band4Value1, band5Value1, band1Condition1, band2Condition1);
        if (classname == '') { this.band_calculated = 'gray-bar'; return false; } else { this.band_calculated = classname; }

      }

      //Comment require
      if (classname == 'red-bar') {

        if (comment == '' || comment == null) {
         // Swal.fire('Error', 'Please Enter Justification', 'error')
          this.toaster.show('error', 'Error', 'Please Enter Justification');
          return false;
        }
      }


      if (this.NANRVal == '') {
        if (classname == 'red-bar') {
          objKPIView.bandColorFinal = 'Red';
        }
        else if (classname == 'orange-bar') {
          objKPIView.bandColorFinal = 'Orange';
        }
        else if (classname == 'yellow-bar') {
          objKPIView.bandColorFinal = 'Yellow';
        }
        else if (classname == 'light-green-bar') {
          objKPIView.bandColorFinal = 'Light Green';
        }
        else if (classname == 'green-bar') {
          objKPIView.bandColorFinal = 'Green';
        }
      }
      else {
        this.band_calculated = 'gray-bar';
      }

      if (type == 'submit') {
        this.modalRef.hide();
        Swal.fire({
          title: 'Please Confirm to Submit the value?',
          html:
            '<div class="line-bg">Band:   <span class="' + classname + '"></span></div>',
          type: 'info',
          showCancelButton: true,
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.value) {

            objKPIView.isWellPerformed = this.getWellPerform(slaRuleUno, classname);
            this.CallUpdate(objKPIView);

            return;
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            return;
          }
        })
      }

    }
    else {
      if (type == 'submit') {
        let classname = (passfail != '' && passfail == 'Pass') ? 'green-bar' : 'red-bar'
        Swal.fire({
          title: 'Please Confirm to Submit the value?',
          html:
            '<div class="line-bg">Band:   <span class="' + classname + '"></span></div>',
          type: 'info',
          showCancelButton: true,
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.value) {

            objKPIView.bandColorFinal = (passfail != '' && passfail == 'Pass') ? 'Green' : 'Red';
            objKPIView.isWellPerformed = (passfail != '' && passfail == 'Pass') ? 1 : 0;
            this.CallUpdate(objKPIView);

            return;
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            return;
          }
        })
      }



    }

    return true;

  }
  deleteKPITran_forAdmin(data: any) {
    Swal.fire({
      title: 'Please confirm to delete the KPI Transaction?',
      type: 'info',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {


        let objKPIView = new kpiViewWorkFlow();
        objKPIView.action = 'delete';
        objKPIView.selectedNANR = '';
        objKPIView.kpiTrnUno = data.kpiTrnUno;
        objKPIView.comment = 'Deleted by admin';
        objKPIView.userUno = this.login_UserID;
        objKPIView.passFail = '';
        objKPIView.targetEnteredValue = 0;
        objKPIView.condition = 1;//(this.pageAction == "add") ? 0 : 1;
        objKPIView.saveAction = 'submit';
        this.CallUpdate(objKPIView);

        return;
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      }
    })

  }

  showKPIBand() {
    //this.loadKPIViewBand(this.kpiUno);
   
    this.modalRef = this.modalService.show(
      this.BandDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  GetBandColorClass(slaRuleUno: number) {
    
    let targetEnValue = 0;
    //Get Selected Vlaues
    let selectNANR = (this.NANRVal == null || this.NANRVal == undefined) ? '' : this.NANRVal;
    if (selectNANR == '') {


      let objTargetEnValue = this.kpiRuleForm.get('enteredTargetValue').value;
      //Target Value validation
      if ((objTargetEnValue == null || objTargetEnValue == '') && selectNANR == '') {
        //Swal.fire('Error', 'Please Enter the Target value', 'error')
        this.toaster.show('error', 'Error', 'Please Enter the Target value');
        return false;
      }
      targetEnValue = (objTargetEnValue != '' && objTargetEnValue != null) ? parseInt(objTargetEnValue) : 0;

      //0-Target Class Get
      if (slaRuleUno == 3) {
        this.band_calculated = (targetEnValue == 0) ? "green-bar" : "red-bar";
        return true;
      }

      //Pas/Fail Class Get
      if (slaRuleUno == 4) {
        let passfail = (this.kpiRuleForm.get('selectPassFail') != null) ? this.kpiRuleForm.get('selectPassFail').value : '';
        if (passfail == '')
          //Swal.fire('Error', 'Please Select the Pass/Fail value', 'error')
          this.toaster.show('error', 'Error', 'Please Select the Pass/Fail value');
        this.band_calculated = (passfail == 'Fail') ? "red-bar" : "green-bar";
        return true;
      }

      //Other Types Class Get

      if (targetEnValue > this.actualTargetValue) {
        //  Swal.fire('Error', ' Actual Value should <=' + this.actualTargetValue, 'error')
        // return false;
      }
      this.band_calculated = '';
      let band1Value1 = this.kpiViewBand_data.band1Value1;
      let band2Value1 = this.kpiViewBand_data.band2Value1;
      let band3Value1 = this.kpiViewBand_data.band3Value1;
      let band4Value1 = this.kpiViewBand_data.band4Value1;
      let band5Value1 = this.kpiViewBand_data.band5Value1;
      let band1Condition1 = this.kpiViewBand_data.band1Condition1;
      let band2Condition1 = this.kpiViewBand_data.band2Condition1;

      let classname = this.getBadcolorFinal(slaRuleUno, targetEnValue, band1Value1, band2Value1, band3Value1, band4Value1, band5Value1, band1Condition1, band2Condition1);
      if (classname == '') { this.band_calculated = 'gray-bar'; return false; } else { this.band_calculated = classname; }


    }
    else {
      this.band_calculated = 'gray-bar';
    }

  }

  getBadcolorFinal(slaRuleUno: any, targetEnValue: any, band1Value1: number, band2Value1: number, band3Value1: number, band4Value1: number, band5Value1: number, band1Condition1: number, band2Condition1: number) {
    

    let classname: string = '';
    let targetEnValue_tmp = targetEnValue;
    if ((this.kpiViewBand_data.bandtype == 2)) {
      targetEnValue_tmp = ((targetEnValue / this.actualTargetValue) * 100).toFixed();

      if (slaRuleUno == 2) {
        let tr = (this.actualTrend == "1") ? 1 : -1;
        targetEnValue_tmp = (((targetEnValue - this.actualTargetValue) * tr) / this.actualTargetValue) * 100;
        targetEnValue_tmp = (targetEnValue_tmp > 100) ? 100 : targetEnValue_tmp;
      }
    }
    if (slaRuleUno == 11) {
      //if (targetEnValue > band5Value1) {
      //Swal.fire('Error', ' Target Value should <=' + band5Value1, 'error')
      //classname='';
      // }

      if (targetEnValue_tmp <= band1Value1) {
        classname = "red-bar";
      }
      else if ((targetEnValue_tmp >= band1Value1) && (targetEnValue_tmp <= band2Value1)) {

        classname = "red-bar";
      }
      else if ((targetEnValue_tmp >= band2Value1) && (targetEnValue_tmp <= band3Value1)) {

        classname = "orange-bar";
      }
      else if ((targetEnValue_tmp >= band3Value1) && (targetEnValue_tmp <= band4Value1)) {

        classname = "yellow-bar";
      }
      else if ((targetEnValue_tmp >= band4Value1) && (targetEnValue_tmp < band5Value1)) {

        classname = "light-green-bar";
      }
      else if (targetEnValue_tmp >= band5Value1) {

        classname = "green-bar";
      }
    }
    else if (slaRuleUno == 2 || slaRuleUno == 1) {

      //if (targetEnValue_tmp <= band1Value1) {
      //  classname = "red-bar";
      //}
      //else if ((targetEnValue_tmp >= band1Value1) && (targetEnValue_tmp <= band2Value1)) {

      //  classname = "green-bar";
      //}
      //else if (targetEnValue_tmp > band2Value1) {

      //  classname = "green-bar";
      //}
      if (
        (targetEnValue_tmp > band1Value1 && band1Condition1 == 1) || //conditon type >
        (targetEnValue_tmp >= band1Value1 && band1Condition1 == 2) || //conditon type >=
        (targetEnValue_tmp == band1Value1 && band1Condition1 == 3) || //conditon type ==
        (targetEnValue_tmp < band1Value1 && band1Condition1 == 4) || //conditon type <
        (targetEnValue_tmp <= band1Value1 && band1Condition1 == 5)  //conditon type <=
      ) {
        classname = "red-bar";
      }
      if (
        (targetEnValue_tmp > band2Value1 && band2Condition1 == 1) || //conditon type >
        (targetEnValue_tmp >= band2Value1 && band2Condition1 == 2) || //conditon type >=
        (targetEnValue_tmp == band2Value1 && band2Condition1 == 3) || //conditon type ==
        (targetEnValue_tmp < band2Value1 && band2Condition1 == 4) || //conditon type <
        (targetEnValue_tmp <= band2Value1 && band2Condition1 == 5)  //conditon type <=
      ) {
        classname = "green-bar";
      }
      //entered value is greater than the target value then passed as green (Well performed) -- when performance is empty
      if (classname == '') {
        if (targetEnValue >= this.actualTargetValue) classname = "green-bar";
      }
    }
    else if (slaRuleUno == 3) {

      
      if (targetEnValue_tmp == 0) {
        classname = "green-bar";
      }
      else {

        classname = "red-bar";
      }

    }

    return classname;
  }

  getWellPerform(slaRuleUno: any, classname: string) {
    let rtnValue: number = 0;
    if (slaRuleUno == 11) {
      if (classname == 'red-bar') {
        rtnValue = (this.kpiViewBand_data.band1wellperform) ? 1 : 0;
      }
      else if (classname == 'orange-bar') {
        rtnValue = (this.kpiViewBand_data.band2wellperform) ? 1 : 0;
      }
      else if (classname == 'yellow-bar') {
        rtnValue = (this.kpiViewBand_data.band3wellperform) ? 1 : 0;
      }
      else if (classname == 'light-green-bar') {
        rtnValue = (this.kpiViewBand_data.band4wellperform) ? 1 : 0;
      }
      else if (classname == 'green-bar') {
        rtnValue = (this.kpiViewBand_data.band5wellperform) ? 1 : 0;
      }
    }
    if (slaRuleUno == 2 || slaRuleUno == 1) {
      if (classname == 'red-bar') {
        rtnValue = (this.kpiViewBand_data.band1wellperform) ? 1 : 0;
      }
      else if (classname == 'green-bar') {
        rtnValue = (this.kpiViewBand_data.band2wellperform) ? 1 : 0;
      }
    }
    if (slaRuleUno == 3) {
      if (classname == 'red-bar') {
        rtnValue = 0;
      }
      else if (classname == 'green-bar') {
        rtnValue = 1;
      }
    }
    return rtnValue;
  }

  CallUpdate(objKPIView: kpiViewWorkFlow) {
    
    objKPIView.tenantUno = 1;
    objKPIView.dataOwnerUno = this.kpiCodeDetail.dataOwnerActionByUno.toString();
    objKPIView.level1ApproverUno = this.kpiCodeDetail.level1ApproverUno;
    objKPIView.level2ApproverUno = this.kpiCodeDetail.level2ApproverUno;
    objKPIView.level3ApproverUno = this.kpiCodeDetail.level3ApproverUno;
    objKPIView.kpiYear = this.kpiCodeDetail.kpiYear;
    objKPIView.kpiQuarter = this.kpiCodeDetail.kpiQuarter;
    objKPIView.kpiUno = this.kpiCodeDetail.kpiUno;
    objKPIView.kpiNameEn = this.kpiCodeDetail.kpiNameEn;
    objKPIView.kpiYearName = this.kpiCodeDetail.kpiYearName;
    objKPIView.kpiQuarterName = this.kpiCodeDetail.kpiQuarterName;
    objKPIView.targetValue = this.kpiCodeDetail.targetValue;
    objKPIView.actualTargetValue = this.kpiCodeDetail.actualTargetValue;

    this.restApi.addKpiViewWorkflow(objKPIView)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong!');
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Saved Successfully',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('success', 'Success', 'KPI Saved Successfully');
          this.kpiRuleForm.reset();

        }

        this.modalRef.hide();
        this.spinner.hide();
        this.loadKPIInbox();
        //this.loadKPIInboxCount();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
          this.modalRef.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
        //  this.KPIDataEntryDialog.show();
      });
    return true;
  }

  onchangeNANR(e) {
    
    this.NANRVal = '';
    if (e != null && e.target.checked) {
      this.NANRVal = 'NA';
      this.kpiRuleForm.get('enteredTargetValue').reset();
      this.kpiRuleForm.get('enteredTargetValue').disable();

      this.kpiRuleForm.get('selectPassFail').reset();
      this.kpiRuleForm.get('selectPassFail').disable();

      this.band_calculated = 'gray-bar';

    }
    else {
      this.NANRVal = '';
      this.kpiRuleForm.get('enteredTargetValue').enable();
      this.kpiRuleForm.get('selectPassFail').enable();
    }
  }


  checkCurrentUserAndLevel(data: any) {

    this.currentLevelUser = '';
    this.currentLevel = 0;
    this.isCurrentLevelUser = false;
    //checking Current level

    this.currentLevel = this.getCurrentLevel(data);
    this.currentLevelUser = this.getCurrentLevelUser(data);

    //Checking whether loggged user and current level user same or not
    //this.kpiCodeDetail.currentLevel = currentLevel;

    let login_UserID = this.RASHelper.decryptWithPrivateKey(this.login_UserID.toString());
    //currentLevelUser = "2,3";
    if (this.currentLevelUser.toString().indexOf(',') > -1) {
      let userArr = this.currentLevelUser.toString().split(',');
      for (let num of userArr) {
        if (login_UserID.toString() == num) {
          this.isCurrentLevelUser = true;
        }
      }
    }
    else {
      if (login_UserID.toString() == this.currentLevelUser.toString()) {
        this.isCurrentLevelUser = true;
      }
    }
    if (this.isAdmin) { this.isCurrentLevelUser = true; }
    return this.isCurrentLevelUser;
  }

  getCurrentLevel(data: any) {
    //currentLevel 0 - Data Entry
    //currentLevel 1 - Level 1 
    //currentLevel 2 - Level 2 
    //currentLevel 3 - Level 3
    let dataEntry = data.dataOwnerActionBy;
    let level1Approved = data.level1Approved;
    let level2Approved = data.level2Approved;
    let level3Approved = data.level3Approved;

    if (dataEntry == "" && level1Approved == 0 && level2Approved == 0 && level3Approved == 0) {
      return 0;
    }
    else if (dataEntry != "" && level1Approved == 0 && level2Approved == 0 && level3Approved == 0) {
      return 1;
    }
    else if (dataEntry != "" && level1Approved == 1 && level2Approved == 0 && level3Approved == 0) {
      return 2;
    }
    else if (dataEntry != "" && level1Approved == 1 && level2Approved == 1 && level3Approved == 0) {
      return 3;
    }
    if (level1Approved == 1 && level2Approved == 1 && level3Approved == 1) {
      return 4;
    }

  }
  getCurrentLevelUser(data: any) {
    //currentLevel 0 - Data Entry
    //currentLevel 1 - Level 1 
    //currentLevel 2 - Level 2 
    //currentLevel 3 - Level 3
    let dataEntry = data.dataOwnerActionBy;
    let level1Approved = data.level1Approved;
    let level2Approved = data.level2Approved;
    let level3Approved = data.level3Approved;

    if (dataEntry == "" && level1Approved == 0 && level2Approved == 0 && level3Approved == 0) {
      return data.dataOwnerUno;
    }
    else if (dataEntry != "" && level1Approved == 0 && level2Approved == 0 && level3Approved == 0) {
      return data.level1ApproverUno;
    }
    else if (dataEntry != "" && level1Approved == 1 && level2Approved == 0 && level3Approved == 0) {
      return data.level2ApproverUno;
    }
    else if (dataEntry != "" && level1Approved == 1 && level2Approved == 1 && level3Approved == 0) {
      return data.level3ApproverUno;
    }
    if (level1Approved == 1 && level2Approved == 1 && level3Approved == 1) {
      return "";
    }

  }

 

  // Choose city using select dropdown
  onchangeSLA(e) {
    
    //alert(e.itemData.slaUno);
    this.slaUno = (e && e.length > 0) ? e[0].value : 0;
    if (!this.isStart) {
      this.loadKPIInbox();
      this.loadPerformanceDashBoard();
    }

  }
  onchangeChart(e) {
    

    this.chartValue = (e && e.length > 0) ? e[0].value : 'Quarter';
    if (!this.isStart) {
     
      this.loadPerformanceDashBoard();
    }
  }
  onchangeFilter(e) {
    
    //alert(e.itemData.slaUno);
    let filterdata = (e.itemData != null) ? e.itemData.value : '';
    if (filterdata != '') {
      this.onfilterData(filterdata, '');
    }
    else {
      this.filterCompleted_classactive = 'active';
      this.filterDataCollection = 0;
      this.filterOverdue = 0;
      this.filterApproval = 0;
      this.filterCompleted = 0;
      this.loadKPIInbox();
      //this.loadKPIInboxCount();
    }

  }

  drawertoggle() {
    
    this.isToggle = (this.isToggle) ? false : true;
  }

  onchangeYear(e) {
    
    this.yearUno = (e && e.length > 0) ? e[0].value : 0;
    this.currentYear = this.yearUno;
    if (!this.isStart) {
      this.loadKPIInbox();
      this.loadPerformanceDashBoard();
      //this.loadKPIInboxCount();
    }
  }

  onchangeQuarter(e) {
    this.quarterUno = (e && e.length > 0) ? e[0].value : 0;
    this.currentQuarter = this.quarterUno;
    if (!this.isStart) {
      this.loadKPIInbox();
      this.loadPerformanceDashBoard();
      
    }
  }

  onchangeDivision(e) {

    this.divisionUno = (e && e.length > 0) ? e[0].value : 0;

    if (e && e.length > 0) {
      this.strDivisionLegend = e[0].text
    }
    else {
      this.strDivisionLegend = (this.tenantUno > 1) ? "":"DEWA";
    } 
    
    if (!this.isStart) {
      this.loadKPIInbox();
      this.loadPerformanceDashBoard();
      
    }
  }

  onchangeFrequency(e) {
    this.frequencyUno = (e && e.length > 0) ? e[0].value : 0;
    if (!this.isStart) {
      this.loadKPIInbox();
      this.loadPerformanceDashBoard();
      //this.loadKPIInboxCount();
    }
  }

  viewKPIHistoryAll(kpiUno: any, kpiNameEn: any) {
    this.kpiUnoSelected = kpiUno;
    this.kpinameSelected = kpiNameEn;
    this.kpiAllHistoryComponent.viewKPI(kpiUno);
  
    this.modalRef = this.modalService.show(
      this.KPIAllHistoryDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );

  }


  viewKPIChartDialogOpen(kpiUno: any, kpiNameEn: any, isFilter: boolean) {
    this.kpinameSelected = kpiNameEn;
    this.titlechart = 'KPI Chart: ' + this.kpinameSelected;
    this.chartType = "Yearly";
    this.ChartinpType = "y";
    this.viewKPIChart(kpiUno, kpiNameEn, isFilter);
  }
  viewKPIChart(kpiUno: any, kpiNameEn: any, isFilter: boolean) {
    this.isKpichartload = true;
    this.ChartKPIdatamain = null;
    this.kpiUnoSelected = kpiUno;
    this.kpinameSelected = kpiNameEn;
    this.titlechart = (this.yearUno_chart == 0) ? 'KPI Chart: ' + this.kpinameSelected : 'KPI Chart [ ' + this.yearUno_chart + ' ]: ' + this.kpinameSelected;
    if (!isFilter) {
      // this.inpyeardata_chart.value = Number(this.yearUno);
      //this.inpyeardata_chart_Q.value = Number(this.yearUno);
      //this.yearUno_chart = this.currentYear;
      //this.yearUno_chart = 0;
      //this.quaterUno_chart = 0;
    }

    //Get The Chart Value
    
    this.spinner.show();
    let inpValue = new kpiInbox();
    inpValue.kpiUno = kpiUno;
    inpValue.kpiYear = this.yearUno_chart;
    inpValue.kpiQuarter = this.quaterUno_chart;
    inpValue.userUno = this.login_UserID;
    inpValue.scheduleText = (this.ChartinpType == 'y') ? 'year' : 'quarter';
    this.restApi.getKpiYearWiseChart(inpValue)
      .subscribe(data => {
        
        setTimeout(() => {
          this.ChartKPIdatamain = data;
          this.isKpichartload = false;
          this.spinner.hide();
          if (!isFilter) {
          
            this.modalRef = this.modalService.show(
              this.KPIChartDialog,
              Object.assign({}, {
                class: 'gray modal-lg',
                backdrop: true,
                keyboard: true,
                focus: true,
                show: false,
                ignoreBackdropClick: true,
                animated: true
              })
            );
          }
        }, 1000);

        // let chartComponent1: any = getInstance('#chart-container', Chart);
        // chartComponent1.refresh();



      },
        (error) => {
          //Called when error
          this.spinner.hide();
          this.isKpichartload = false;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        // this.spinner.hide();

      });



  }

  onchangeYear_Chart(e) {
    //if (!this.isStart) {
    this.yearUno_chart = (e && e.length > 0) ? e[0].value : 0;
    this.viewKPIChart(this.kpiUnoSelected, this.kpinameSelected, true);
    //}
  }
  onchangeYear_Chart_Q(e) {
    //if (!this.isStart) {
    this.yearUno_chart = (e && e.length > 0) ? e[0].value : 0;
    this.viewKPIChart(this.kpiUnoSelected, this.kpinameSelected, true);
    //}
  }
  onchange_ChartType(e) {
    

    let val = (e && e.length > 0) ? e[0].value : '';
    if (val == 'Yearly') {
      this.quaterUno_chart = 0;
      this.ChartinpType = 'y';
      this.yearUno_chart = 0;
      this.quaterUno_chart = 0;
      if (!this.isStart) {
        // this.inpyeardata_chart.value = null;       
      }
      //  
    }
    else {
      this.ChartinpType = 'q';
      this.yearUno_chart = this.yearUno;
      this.quaterUno_chart = 0;
      if (!this.isStart) {

        //this.inpyeardata_chart_Q.value = Number(this.yearUno);
        // this.inpquaterdata_chart.value = null;

      }

    }
    let tempthis = this;
    //setTimeout(() => {
    
    if (!this.isStart) {
      this.viewKPIChart(this.kpiUnoSelected, this.kpinameSelected, true);
    }
    //}, 200);

  }
  onchangeQuarter_Chart(e) {
    if (!this.isStart) {
      this.quaterUno_chart = (e && e.length > 0) ? e[0].value : 0;;
      this.viewKPIChart(this.kpiUnoSelected, this.kpinameSelected, true);
    }
  }
  getChartType() {
    this.chartTypedata = [
      { text: 'Yearly', value: 'Yearly' },
      { text: 'Quarterly', value: 'Quarterly' }
    ];
  }

  onfilterData(type: string, ev: any) {
    if (type != 'color_red' && type != 'color_orange' && type != 'color_yellow' && type != 'color_lightgreen' && type != 'color_green') {
      this.filterDataCollection = (type == 'data') ? 1 : 0;
      this.filterOverdue = (type == 'overdue') ? 1 : 0;
      this.filterCompleted = (type == 'completed') ? 1 : 0;
      this.filterApproval = (type == 'approval') ? 1 : 0;
      this.filterAll_classactive = (type == 'all') ? 'active' : '';
      this.filterDataCollection_classactive = (type == 'data') ? 'active' : '';
      this.filterOverdue_classactive = (type == 'overdue') ? 'active' : '';
      this.filterCompleted_classactive = (type == 'completed') ? 'active' : '';
      this.filterApproval_classactive = (type == 'approval') ? 'active' : '';
      this.checkboxDisable = (this.filterDataCollection == 1 || this.filterCompleted == 1) ? false : true;
    }

    //for Color
    if (type == 'color_red') {
      
      type = type + ',';
      var split_str = this.filterColor.split(",");
      this.filterColor = (split_str.indexOf("Red") !== -1 || !ev.target.checked) ? this.filterColor.replace('Red,', '') : this.filterColor + 'Red,';
    }
    else if (type == 'color_orange') {
      type = type + ',';
      var split_str = this.filterColor.split(",");
      this.filterColor = (split_str.indexOf("Orange") !== -1 || !ev.target.checked) ? this.filterColor.replace('Orange,', '') : this.filterColor + 'Orange,';
    }
    else if (type == 'color_yellow') {
      type = type + ',';
      var split_str = this.filterColor.split(",");
      this.filterColor = (split_str.indexOf("Yellow") !== -1 || !ev.target.checked) ? this.filterColor.replace('Yellow,', '') : this.filterColor + 'Yellow,';
    }
    else if (type == 'color_lightgreen') {
      type = type + ',';
      var split_str = this.filterColor.split(",");
      this.filterColor = (split_str.indexOf("Light") !== -1 || !ev.target.checked) ? this.filterColor.replace('Light Green,', '') : this.filterColor + 'Light Green,';
    }
    else if (type == 'color_green') {
      type = type + ',';
      var split_str = this.filterColor.split(",");
      this.filterColor = (split_str.indexOf("Green") !== -1 || !ev.target.checked) ? this.filterColor.replace('Green,', '') : this.filterColor + 'Green,';
    }
    this.loadKPIInbox();
    //this.loadKPIInboxCount();
  }

  //public onFilteringYear: any = (e: FilteringEventArgs) => {
  //  // take text for highlight the character in list items.   
  //  let query: Query = new Query().select(['displayText', 'value']);
  //  query = (e.text !== '') ? query.where('displayText', 'startswith', e.text, true) : query;
  //  e.updateData(this.yearData, query);
  //};
  //public onFilteringQuater: any = (e: FilteringEventArgs) => {
  //  // take text for highlight the character in list items.   
  //  let query: Query = new Query().select(['displayText', 'value']);
  //  query = (e.text !== '') ? query.where('displayText', 'startswith', e.text, true) : query;
  //  e.updateData(this.quaterData, query);
  //};
  //public onFilteringFrequency: any = (e: FilteringEventArgs) => {
  //  // take text for highlight the character in list items.   
  //  let query: Query = new Query().select(['frequencyName', 'frequencyCode']);
  //  query = (e.text !== '') ? query.where('frequencyName', 'startswith', e.text, true) : query;
  //  e.updateData(this.frequency_data, query);
  //};

 
  //************************** KPI Reset ******************************
  sendKPIReset(objSelected: any) {
    
    this.objkpiRelease = new kpiReset();
    let objKR = new kpiReset();
    let objitem: any = objSelected;
    objKR = objitem;
    objKR.kpiTrnUno = objitem.kpiTrnUno;
    objKR.kpiUno = objSelected.kpiUno;
    objKR.tenantUno = this.tenantUno;
    objKR.slakpiYearUno = objitem.slakpiYearUno;
    this.objkpiRelease.dataOwnerActionByUno = this.utilityService.isNumericNull(objitem['dataOwnerActionByUno']);
    this.objkpiRelease.level1Approved = this.utilityService.isNumericNull(objitem['level1Approved']);
    this.objkpiRelease.level2Approved = this.utilityService.isNumericNull(objitem['level2Approved']);
    this.objkpiRelease.level3Approved = this.utilityService.isNumericNull(objitem['level3Approved']);

    this.objkpiRelease.objkpiReset.push(objKR);
    this.AddKPIReset();

  }
  AddKPIReset() {

    let data: any = this.objkpiRelease;
    
    if (this.resetType_txt != undefined && this.resetType_txt != null)
      this.resetType_txt = '';
    if (this.objkpiRelease.objkpiReset.length <= 0) {
      //Swal.fire('Error', 'KPI is not selected ', 'warning');
      this.toaster.show('error', 'Error', 'KPI is not selected');
    }
    else {

      if (data.level1Approved == 0 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno == 0) {
        this.resettype_data = [
          { resettypeCode: 1, resettypeName: 'Draft' }

        ];
      }
      if (data.level1Approved == 0 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0) {
        this.resettype_data = [
          { resettypeCode: 1, resettypeName: 'Draft' },
          { resettypeCode: 2, resettypeName: 'Data Collection' }
        ];
      }
      if (data.level1Approved == 1 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0) {
        this.resettype_data = [
          { resettypeCode: 1, resettypeName: 'Draft' },
          { resettypeCode: 2, resettypeName: 'Data Collection' },
          { resettypeCode: 3, resettypeName: 'Pending for Approval - 1' }
        ];
      }
      if (data.level1Approved == 1 && data.level2Approved == 1 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0) {
        this.resettype_data = [
          { resettypeCode: 1, resettypeName: 'Draft' },
          { resettypeCode: 2, resettypeName: 'Data Collection' },
          { resettypeCode: 3, resettypeName: 'Pending for Approval - 1' },
          { resettypeCode: 4, resettypeName: 'Pending for Approval - 2' }
        ];
      }
      if (data.level1Approved == 1 && data.level2Approved == 1 && data.level3Approved == 1 && data.dataOwnerActionByUno > 0) {
        this.resettype_data = [
          { resettypeCode: 1, resettypeName: 'Draft' },
          { resettypeCode: 2, resettypeName: 'Data Collection' },
          { resettypeCode: 3, resettypeName: 'Pending for Approval - 1' },
          { resettypeCode: 4, resettypeName: 'Pending for Approval - 2' },
          { resettypeCode: 5, resettypeName: 'Pending for Approval - 3' }
        ];
      }

    
      this.modalRef = this.modalService.show(
        this.ResetDialog,
        Object.assign({}, {
          class: 'gray m-auto modal-s',
          backdrop: true,
          keyboard: true,
          focus: true,
          show: false,
          ignoreBackdropClick: true,
          animated: true
        })
      );
      this.isResetTypeErr = false;
      this.isCommentErr = false;

    }
    return true;

  }
  AddKPIResetFormSubmit() {
    
    this.objkpiRelease.userUno = this.login_UserID;
    this.objkpiRelease.resetComment = this.resetComment;
    this.objkpiRelease.resetType = this.resetType_txt;

    if (this.isResetType) {
      if (this.resetType_txt == '') {
        //Swal.fire('Error', 'Please select reset type', 'error')
        this.toaster.show('error', 'Error', 'Please select reset type');
        this.isResetTypeErr = true;
        return false;
      }
      if (this.resetComment == '') {
        //Swal.fire('Error', 'Please enter comment', 'error')
        this.toaster.show('error', 'Error', 'Please enter comment');
        this.isCommentErr = true;
        return false;
      }
    }
    else {

      if (this.resetComment == '') {
       // Swal.fire('Error', 'Please enter comment', 'error')
        this.toaster.show('error', 'Error', 'Please enter comment');
        this.isCommentErr = true;
        return false;
      }
    }

    Swal.fire({
      title: 'Reset',
      text: 'Please Confirm to Reset the KPI',
      type: 'info',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        

        this.restApi.addKpiReset(this.objkpiRelease)
          .subscribe(data => {

            if (data != null && data != undefined && data != '') {
            //  Swal.fire('Error', 'Something went wrong', 'error')
              this.toaster.show('error', 'Error', 'Something went wrong');
            }
            else {
              //Swal.fire({
              //  type: 'success',
              //  title: 'KPI Resetted Successfully',
              //  showConfirmButton: false,
              //  timer: 1500
              //})
              this.toaster.show('success', 'Success', 'Something went wrong');
              // this.loadKPIRelease(4);
              this.loadKPIInbox();
              //this.loadKPIInboxCount();
            }


            this.spinner.hide();
          },
            (error) => {
              //Called when error
              this.spinner.hide();
            }
          ).add(() => {
            //Called when operation is complete (both success and error)
            this.spinner.hide();
            this.resetComment = '';
            this.resetType_txt = '';
          });
        return;
      } else if (result.dismiss === Swal.DismissReason.cancel) {

        return;
      }
    })

    this.modalRef.hide();
  }
  onchangeResetType(e) {

    this.resetType_txt = (e && e.length > 0 && e[0].resettypeName != 'All') ? e[0].resettypeName : '';
    this.isResetTypeErr = false;
    // this.onSelectedTab();
  }
  loadResetType() {
    this.resettype_data = [
      { resettypeCode: 1, resettypeName: 'Draft' },
      { resettypeCode: 2, resettypeName: 'Data Collection' },
      { resettypeCode: 3, resettypeName: 'Pending for Approval - 1' },
      { resettypeCode: 4, resettypeName: 'Pending for Approval - 2' },
      { resettypeCode: 5, resettypeName: 'Pending for Approval - 3' }
    ];
  }

  onDialogCloseEvent(event: any) {

    this.loadKPIInbox();
    //this.loadKPIInboxCount();

  }

  //************************** KPI Reset End******************************

 
  //loadedChartDowload(args: ILoadedEventArgs) {
  //  this.loadedChartVal = args;
  //}

  chartDownload() {

    this.loadedChartVal.chart.exportModule.export('PNG', 'export');
    //setTimeout(() => { this.titlechart = 'KPI Chart'; }, 300);
  }

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  exportToExcelIssue() {
    var temp = this;
    setTimeout(function () {
      temp.issueGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  exportToExcelCmt() {
    var temp = this;
    setTimeout(function () {
      temp.cmtsGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }

  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.kpiCode && a.kpiCode.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.kpiName && a.kpiName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.slaName && a.slaName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.divisionName && a.divisionName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.scheduleName && a.scheduleName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.year && a.year.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.quarter && a.quarter.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.targetValueText && a.targetValueText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.actualValueText && a.actualValueText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.kpiRule && a.kpiRule.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.type && a.type.toLowerCase().includes(this.searchText.toLowerCase()))
        
      );
    }
    else
      this.dataset = this.dataSearch;
  }

  //setColnDefn() {
  //  let temp = this;
  //  this.columnDefinitions = [
  //    {
  //      id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
  //      type: FieldType.string, filterable: true,
  //      filter: {
  //        collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
  //        model: Filters.multipleSelect,
  //      }
  //    },
  //    {
  //      id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true, width: 300,
  //      type: FieldType.string, filterable: true,
  //      filter: {
  //        collection: this.uniqueArray(this.dataset, 'kpiNameEn', 'kpiNameEn'),
  //        model: Filters.multipleSelect,
  //      }
  //    },
  //    {
  //      id: 'kpiYearName', name: 'Year', field: 'kpiYearName', sortable: true,
  //      type: FieldType.string, filterable: true,
  //      filter: {
  //        collection: this.uniqueArray(this.dataset, 'kpiYearName', 'kpiYearName'),
  //        model: Filters.multipleSelect,
  //      },

  //    },
  //    {
  //      id: 'kpiQuarterName', name: 'Quarter', field: 'kpiQuarterName', sortable: true,
  //      type: FieldType.string, filterable: true,
  //      filter: {
  //        collection: this.uniqueArray(this.dataset, 'kpiQuarterName', 'kpiQuarterName'),
  //        model: Filters.multipleSelect,
  //      },
  //    },
  //    {
  //      id: 'scheduleText', name: 'Frequency', field: 'scheduleText', sortable: true,
  //      type: FieldType.string, filterable: true,
  //      filter: {
  //        collection: this.uniqueArray(this.dataset, 'scheduleText', 'scheduleText'),
  //        model: Filters.multipleSelect,
  //      },
  //      formatter: (row, cell, val, columnDef, dataContext) => {
  //        if (dataContext.scheduleUno == 1)
  //          return 'Yearly';
  //        else if (dataContext.scheduleUno == 2)
  //          return 'Semi-annually';
  //        else if (dataContext.scheduleUno == 3)
  //          return 'Quarterly';
  //        else if (dataContext.scheduleUno == 4)
  //          return 'Monthly';
  //        else
  //          return '';
  //      }
  //    },
  //    {
  //      id: 'periodDisplay', name: 'Period', field: 'periodDisplay', sortable: true, type: FieldType.string, filterable: true,
  //      filter: {
  //        collection: this.uniqueArray(this.dataset, 'periodDisplay', 'periodDisplay'),
  //        model: Filters.multipleSelect,

  //      }
  //    },

  //    {
  //      id: 'slaRuleName', name: 'KPI Type', field: 'slaRuleName', sortable: true, type: FieldType.string, filterable: true,
  //      filter: {
  //        collection: this.uniqueArray(this.dataset, 'slaRuleName', 'slaRuleName'),
  //        model: Filters.multipleSelect,
  //      }
  //    },
  //    {
  //      id: 'targetValueText', name: 'Actual', field: 'targetValueText', sortable: true, type: FieldType.string, filterable: true, formatter: this.actualFormatter,
  //      filter: {
  //        collection: this.uniqueArray(this.dataset, 'targetValueText', 'targetValueText'),
  //        model: Filters.multipleSelect,
  //      },

  //    },
  //    {
  //      id: 'actualValueText', name: 'Target', field: 'actualValueText', sortable: true, type: FieldType.string, filterable: true,
  //      filter: {
  //        collection: this.uniqueArray(this.dataset, 'actualValueText', 'actualValueText'),
  //        model: Filters.multipleSelect,
  //      },
  //      formatter: (row, cell, val, columnDef, dataContext) => {
  //        if (dataContext.slaRuleUno != 4)
  //          return dataContext.actualTargetValue;
  //        else
  //          return 'Pass';
  //      }
  //    },
  //    //{
  //    //  id: 'kpiRule', name: 'KPI Rule', field: 'kpiRule', sortable: true, type: FieldType.string, filterable: true,
  //    //  filter: {
  //    //    collection: this.uniqueArray(this.dataset, 'kpiRule', 'kpiRule'),
  //    //    model: Filters.multipleSelect,
  //    //  }
  //    //},
  //    {
  //      id: 'bandValueText', name: 'Status', field: 'bandValueText', selectable: false, type: FieldType.string, filterable: true, formatter: this.bandFormatter,
  //      filter: {
  //        collection: this.uniqueArray(this.dataset, 'bandValueText', 'bandValueText'),
  //        model: Filters.multipleSelect,
  //      }
  //    },
  //    //{
  //    //  id: 'currentStage', name: 'Status', field: 'currentStage', sortable: true, type: FieldType.string, filterable: true,
  //    //  filter: {
  //    //    collection: this.uniqueArray(this.dataset, 'currentStage', 'currentStage'),
  //    //    model: Filters.multipleSelect,
  //    //  },
  //    //  formatter: (row, cell, val, columnDef, data) => {
                      
  //    //    if (data.statusUno == 0)
  //    //      return '<span *ngIf="" class="status-area status-red">Data Entry</span>';
  //    //    else if (data.statusUno == 1)
  //    //      return '<span  class="status-area status-orange">Approval 1</span>';
  //    //    else if (data.statusUno == 2)
  //    //      return '<span  class="status-area status-yellow">Approval 2</span>';
  //    //    else if(data.statusUno == 3)
  //    //      return '<span  class="status-area status-light-green">Approval 3</span>';
  //    //    else if(data.statusUno == 4)
  //    //      return '<span class="status-area status-green">Completed</span>';
  //    //  }
  //    //},
  //    {
  //      id: 'action', name: 'Action', field: 'action', width: 50, cssClass: 'blue',
  //      type: FieldType.string, formatter: (row, cell, val, columnDef, data) => {
  //        if (data.slaRuleUno != 4 && data.slaRuleUno != 3)

  //          return '<span style="cursor:pointer"><i class="fa fa-line-chart fa-lg"></i></span>';
  //        else '';
  //      },
  //      onCellClick: (e: Event, args: OnEventArgs) => {
  //        let rdata: any = args.dataContext;
          
  //        
  //        if (rdata.slaRuleUno != 4 && rdata.slaRuleUno != 3) {

  //          let kpiUno = rdata.kpiUno;
  //          let actual = rdata.targetValueText;
  //          let target = rdata.actualValueText;
  //          let band = rdata.bandColour;

  //          this.slaUno = this.slaUno ? this.slaUno : 0;
  //          this.yearUno = this.yearUno ? this.yearUno : 0;
  //          this.quarterUno = this.quarterUno ? this.quarterUno : 0;
  //          this.divisionUno = this.divisionUno ? this.divisionUno : 0;
  //          this.frequencyUno = this.frequencyUno ? this.frequencyUno : 0;

  //          localStorage.removeItem('SlaKpiPeformanceFilter');
  //          localStorage.setItem('SlaKpiPeformanceFilter', '{"slaUno":"' + this.slaUno + '","yearUno":"' + this.yearUno + '","quarterUno":"' + this.quarterUno + '","divisionUno":"' + this.divisionUno + '","frequencyUno":"' + this.frequencyUno + '"}');

  //          this.router.navigate(['/dashboard-slakpi-view/' + rdata.kpiTrnUno], { queryParams: { actual: actual, target: target, band: band, kpinumber: kpiUno } });

  //          this.router.navigate(['/dashboard-slakpi-view/' + rdata.kpiTrnUno], { queryParams: { actual: actual, target: target, band: band,kpinumber:kpiUno } });
  //        }            
  //        else
  //          return false;
         

  //      }
  //    }
  //  ]


  //}
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true, width: 200,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiName', name: 'KPI', field: 'kpiName', sortable: true, width: 300,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiName', 'kpiName'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'slaName', name: this.slaName, field: 'slaName', sortable: true, width: 150,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'slaName', 'slaName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'divisionName', name: 'Division', field: 'divisionName', sortable: true, width: 100,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'divisionName', 'divisionName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'scheduleName', name: 'Frequency', field: 'scheduleName', sortable: true, width: 100,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'scheduleName', 'scheduleName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'year', name: 'Year', field: 'year', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'year', 'year'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'quarter', name: 'Quarter', field: 'quarter', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'quarter', 'quarter'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'type', name: 'Type', field: 'type', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'type', 'type'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiRule', name: 'Rule', field: 'kpiRule', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiRule', 'kpiRule'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'actualValueText', name: 'Actual', field: 'actualValueText', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'actualValueText', 'actualValueText'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'targetValueText', name: 'Target', field: 'targetValueText', sortable: true, type: FieldType.string, filterable: true,
        formatter: this.targetFormatter,
        filter: {
          collection: this.uniqueArray(this.dataset, 'targetValueText', 'targetValueText'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'bandValueText', name: 'Status', field: 'bandValueText', selectable: false, type: FieldType.string, filterable: true, formatter: this.bandFormatter,
        filter: {
          collection: this.uniqueArray(this.dataset, 'bandValueText', 'bandValueText'),
          model: Filters.multipleSelect,
        }
      },
      //{
      //  id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
      //  excludeFromExport: true,
      //  formatter: this.actionFormatter,
      //  cellMenu: {
      //    hideCloseButton: false,
      //    commandTitleKey: 'COMMANDS',
      //    commandItems: [
      //      {
      //        command: 'KPI-Info-row', titleKey: 'KPIInfo_ROW', positionOrder: 62, title: 'KPI Info',

      //        iconCssClass: 'fa fa-info-circle fa-lg ', cssClass: 'green-text', textCssClass: 'bold',
      //        action: (e, args) => {
      //          this.viewKPIHistoryAll(args.dataContext.kpiUno, args.dataContext.kpiCode + ' : ' + args.dataContext.kpiName)
      //        }
      //      },

      //      {
      //        command: 'KPI-row', titleKey: 'KPI_ROW', positionOrder: 65, title: 'KPI Chart',
      //        iconCssClass: 'fa fa-bar-chart fa-lg ', cssClass: 'red', textCssClass: 'bold',
      //        itemVisibilityOverride: (args: MenuCallbackArgs) => {
      //          let data = args.dataContext;
      //          if (data.slaRuleUno != 4 && data.slaRuleUno != 3)
      //            return true;
      //          else false;
      //        },

      //        action: (e, args) => {
      //          //this.sendKPIReset(args.dataContext);
      //        }
      //      },


      //    ],
      //  }
      //}

    ]



  }
  actualFormatter: Formatter = (row, cell, value, columnDef, data) => {

    if (data.bandColour != '' && data.dataOwnerActionBy != '' && data.slaRuleUno != 4)
      return data.targetValue;
    if ((data.bandColour != '' && data.dataOwnerActionBy != '' && data.slaRuleUno == 4))
      return data.bandColour == 'Green' ? 'Pass' : 'Fail';
    if (data.bandColour == '' && data.dataOwnerActionBy != '' && data.dataOwnerActionBy != null && (data.isNANRNT != null && data.isNANRNT != ''))
      return data.isNANRNT;
    if ((data.dataOwnerExists == 1 || this.isAdmin) && data.bandColour == '' && data.dataOwnerActionBy == '' && (data.isNANRNT == '' || data.isNANRNT == null)) {
      return '<a matTooltipClass="my-custom-tooltip-avg" title="Data Entry"  class="bcopy-btn" style="cursor:pointer !important;">-</a>'
    }
    if (data.bandColour == '' && data.dataOwnerActionBy != '' && data.isNANRNT != '')
      return '<a  style="text-decoration:underline; cursor:pointer;" >' + data.isNANRNT + '</a>';



  };
  targetFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {

    if (dataContext.actualValueText == 'ND' || dataContext.actualValueText == 'NR')
      return `-`
    else
      return dataContext.targetValueText;
  };
  bandFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    if (dataContext.bandValue == '1')
      return `<div class="bg-grey-progress" > <span class="green-bar"></span></div>`;
    if (dataContext.bandValue == '2')
      return `<div class="bg-grey-progress" > <span class="red-bar"></span></div>`;
    if (dataContext.bandValue != 1 && dataContext.bandValue != 2 && dataContext.bandValue == 0)
      if (dataContext.actualValueText == 'ND' || dataContext.actualValueText == 'NR')
        return ``
      else
        return `<div class="bg-grey-progress" > <span class="bluedark-bar"></span></div>`;
  };

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  cmtsGridReady(angularGrid: AngularGridInstance) {
    this.cmtsGrid = angularGrid;
  }

  issueGridReady(angularGrid: AngularGridInstance) {
    this.issueGrid = angularGrid;

  }

  setCommentDefn() {
    this.columnCommentDefinitions = [
      { id: 'action', name: 'Action', field: 'action', sortable: true },
      { id: 'postedBy', name: 'Action By', field: 'postedBy', sortable: true },
      { id: 'postedDate', name: 'Date', field: 'postedDate', sortable: true },
      { id: 'comment', name: 'Comment', field: 'comment', sortable: true },

    ];
  }

  setIssueDefn() {
    setTimeout(() => {
      this.columnIssueDefinitions = [
        { id: 'postedBy', name: 'Action By', field: 'postedBy', sortable: true },
        { id: 'postedDate', name: 'Date', field: 'postedDate', sortable: true },
        { id: 'comment', name: 'Comment', field: 'comment', sortable: true },

      ];
    }, 3000);
  }

  loadPerformanceDashBoard() {


    let inpValue = new performanceDashBoard();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.slaUno = (this.slaUno == 0 || this.slaUno == undefined) ? 0 : this.slaUno;
    inpValue.currentYear = (this.yearUno == 0 || this.yearUno == undefined) ? 0 : this.yearUno;
    inpValue.currentQuarter = (this.quarterUno == 0 || this.quarterUno == undefined) ? 0 : this.quarterUno;
    inpValue.divisionUno = (this.divisionUno == 0 || this.divisionUno == undefined) ? 0 : this.divisionUno;
    inpValue.frequencyUno = (this.frequencyUno == 0 || this.frequencyUno == undefined) ? 0 : this.frequencyUno;
    inpValue.currentHalf = this.currentHalf;
    inpValue.currentMonth = this.currentMonth;
    inpValue.dashboardType = this.chartValue;
    inpValue.pageType = 'slahome';
    //inpValue.wellperformKPIRange = this.wellperformKPIRange;
    
    this.restApi.getPerformanceDashboard(inpValue)
      .subscribe(data => {
        

        this.PerformanceDashboard_data = data[0];

        this.wellPerformedKPICount = this.PerformanceDashboard_data.noOfWellPerformedKPICount;
        this.underPerformedKPICount = this.PerformanceDashboard_data.noOfUnderPerformedKPICount;
        this.KPICount = this.PerformanceDashboard_data.noOfKPICount;
        this.reportedKPICount = this.PerformanceDashboard_data.noOfReportedKPICount;
        this.noOfNAKPICount = this.PerformanceDashboard_data.noOfNAKPICount;
        this.reporting = this.PerformanceDashboard_data.reportingKPICount;
        //this.spinner.show();
        setTimeout(() => {
          //google.charts.load('current', { 'packages': ['corechart'] });
          this.drawSlaChart(this.PerformanceDashboard_data);
          this.spinner.hide();
        }, 300);

        this.totalKPIWPPercentage = (this.wellPerformedKPICount / (this.wellPerformedKPICount + this.underPerformedKPICount)) * 100;
        this.totalKPIWPPercentage = this.RoundNum((isNaN(this.totalKPIWPPercentage) || Number.isNaN(this.totalKPIWPPercentage) || this.totalKPIWPPercentage <= 0) ? 0 : parseFloat(this.totalKPIWPPercentage.toFixed()), 0);
        
        setTimeout(() => {

          //google.charts.load('current', { 'packages': ['corechart'] });
          this.welformedChart(this.PerformanceDashboard_data.list_KPIWPChartList);


          //this.spinner.hide();
        }, 600);

        this.isStart = false;
      },
        (error) => {
          //Called when error
          this.isStart = false;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.isStart = false;
      });

  }

  drawSlaChart = (option_data: any) => {

    //let tempArray = [['SLA', 'Count']];

    //tempArray.push(['Well Performed', '50']);
    //tempArray.push(['Not Well Performed', '50']);
    // var data = google.visualization.arrayToDataTable(tempArray);
    //const data = google.visualization.arrayToDataTable([
    //  ['Performance', 'Types of Reports Submitted'],
    //  ['Well Performed', this.wellPerformedKPICount],
    //  ['Not Well Performed', this.underPerformedKPICount],
    //]);
    //const options = {
    //  //title: 'Types of Reports Submitted',
    //  colors: ['#68b097', '#bcbcbc'],
    //  legend: { position: 'none' },
    //  chartArea: { left: 10, right: 10, top: 0, bottom: 0, width: "100%", height: "100%" },
    //  fontSize: 15
    //};

    //const chart = new google.visualization.PieChart(document.getElementById('SLA_Chart'));
    //chart.draw(data, options);

    let tempArray = [];

    let wellPerformedPercentage = (this.wellPerformedKPICount / (this.wellPerformedKPICount + this.underPerformedKPICount)) * 100;
    wellPerformedPercentage = this.RoundNum((isNaN(wellPerformedPercentage) || Number.isNaN(wellPerformedPercentage) || wellPerformedPercentage <= 0) ? 0 : parseFloat(wellPerformedPercentage.toFixed()), 0);

    let underPerformedPercentage = (this.underPerformedKPICount / (this.wellPerformedKPICount + this.underPerformedKPICount)) * 100;
    underPerformedPercentage = this.RoundNum((isNaN(underPerformedPercentage) || Number.isNaN(underPerformedPercentage) || underPerformedPercentage <= 0) ? 0 : parseFloat(underPerformedPercentage.toFixed()), 0);

    tempArray.push({ name: 'Well Performed', value: wellPerformedPercentage });

    if (this.underPerformedKPICount > 0)
      tempArray.push({ name: 'Not Well Performed', value: underPerformedPercentage });

    //echarts starts
    this.SlaChartOption = {
      tooltip: {
        trigger: "item",
        formatter: "{c}",
        textStyle: {
          fontWeight: "bold",
          fontSize: 13
        }
      },

      legend: {
        show: false,
        //type: 'scroll',
        //orient: 'vertical',
        //right: 0,
        //top: 0,
        //bottom: 20,
        //pageIconColor: '#087b36',
        //pageIconInactiveColor: '#999999'
      },
      color: ['#68b097', '#bcbcbc'],
      
      series: [
        {
          name: '',
          type: 'pie',
          //radius: ['30%', '80%'],
          center: ["50%", "50%"],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'inside',
            color: '#fff',
            fontSize: '12',
            formatter: function (d) {
              return d.value +"%";
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '10',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },

          data: tempArray
        }
      ]
    };
    // echarts ends
  }


  welformedChart = (option_data: any) => {


    let tempArray_XAxis = [];
    let tempArray_Target = [];
    let tempArray_Actual = [];

    for (var i = 0; i < option_data.length; i++) {
      let kpiYearName = option_data[i].year;
      let actualTargetValue = option_data[i].actualValue;
      let targetValue = option_data[i].targetValue;

      tempArray_XAxis.push(kpiYearName);
      tempArray_Target.push(targetValue);
      tempArray_Actual.push(actualTargetValue);
      //  tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue)]);
    }

    let strTargetText = this.strDivisionLegend + " Target";
    let strActualText = this.strDivisionLegend + " Actual";
    this.welformedchartOption = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: [strTargetText, strActualText],
        bottom: '0',
        left: 'center',
        //padding: [
        //  20,  // up
        //  0, // right
        //  0,  // down
        //  0, // left
        //],
      },
      color: ['#68b097', '#9e9e9e'],
      toolbox: {
        show: true,
        feature: {
          //dataView: { show: true, readOnly: false },
          //magicType: { show: true, type: ['line', 'bar'] },
          //restore: { show: true },
          //saveAsImage: { show: true }
        }
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: tempArray_XAxis
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      grid: {
        left: '0',
        top: '10%',
        right: '0',
        bottom: '20%',
        containLabel: true
      },
      dataZoom: [
        {
          show: true,
          start: 1,
          end: 100,
          right: '2%',
          left: '5%',
          top: '72%',
          fillerColor: 'rgba(255, 255, 255, 0)',
          borderColor: '#fff',
          //backgroundColor: 'rgba(255, 255, 255, 1)',
          dataBackground: {
            areaStyle: {
              color: 'rgba(255, 255, 255, 1)',
            }
          },
          showDataShadow: false,
          showDetail: false,
          //zoomSelectionColor: '#fff',
          moveHandleSize: 1.
          

        }

      ],
      series: [
        {
          name: strActualText,
          type: 'bar',
          data: tempArray_Actual,
          barWidth: "5%",

        },
        {
          name: strTargetText,
          type: 'bar',
          data: tempArray_Target,
          barWidth: "5%",


        }
        
      ]
    };


    //let tempArray = [['Quarter', 'DEWA ACTUAL','DEWA TARGET']];
    //for (var i = 0; i < option_data.length; i++) {

    //  tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue)]);

    //}

    //

    //var data = new google.visualization.arrayToDataTable(tempArray);

    ////var data = google.visualization.arrayToDataTable([
    ////  ['Quarter', 'Target'],
    ////  ['2021/Q1',  70],
    ////  ['2021/Q2',  90],
    ////  ['2021/Q3',  60]
    ////]);


    //var options = {
    //  //title: 'Monthly Coffee Production by Country',
    //  colors: ['#45b664', '#0b937e'],
    //  //vAxis: { title: 'Rate' },
    //  hAxis: { title: 'Year' },
    //  seriesType: 'bars',
    //  series: { 5: { type: 'line' } },
    //  legend: { position: 'bottom' },
    //};

    //var chart = new google.visualization.ComboChart(document.getElementById('chart_welformedChart'));
    //chart.draw(data, options);

  }

  public RoundNum(num, length): number {
    
    var number = Math.round(num * Math.pow(10, length)) / Math.pow(10, length);
    return number;
  }
  
  onDbClicked(ev, es) {
    let rdata = this.angularGrid.gridService.getDataItemByRowIndex(es.row)
    if (rdata != null && rdata != undefined) {

      //if (rdata.slaRuleUno != 4 && rdata.slaRuleUno != 3) {
        
        let kpiUno = rdata.kpiUno;
        let target = rdata.targetValueText;
        let actual = rdata.actualValueText;
        let band = '';
        if (rdata.bandValue == 1)
          band = 'Green';
        if (rdata.bandValue == 2)
          band = 'Red';
        if (rdata.bandValue != 1 && rdata.bandValue != 2 && rdata.bandValue == 0)
          band = 'Blue';

        this.slaUno = this.slaUno ? this.slaUno : 0;
        this.yearUno = this.yearUno ? this.yearUno : 0;
        this.quarterUno = this.quarterUno ? this.quarterUno : 0;
        this.divisionUno = this.divisionUno ? this.divisionUno : 0;
        this.frequencyUno = this.frequencyUno ? this.frequencyUno : 0;

        localStorage.removeItem('SlaKpiPeformanceFilter');
        localStorage.setItem('SlaKpiPeformanceFilter', '{"slaUno":"' + this.slaUno + '","yearUno":"' + this.yearUno + '","quarterUno":"' + this.quarterUno + '","divisionUno":"' + this.divisionUno + '","frequencyUno":"' + this.frequencyUno + '"}');
      if (actual != 'ND' && actual != 'NR') {
        this.router.navigate(['/dashboard-slakpi-view/' + rdata.kpiTrnUno], { queryParams: { actual: actual, target: target, band: band, kpinumber: kpiUno, sourcePage: 'slakpi' } });
      }
      }
     
    //}
    return false;
  }
  onClick(e, es) {
    
    this.isSingleClick = true;
    // e.srcElement.className = "active";
    //let objitem = this.angularGrid.gridService.getDataItemByRowIndex(es.row);
    if (this.isSingleClick) {
      this.highlighSelectedRow(es.row);
    }
  }


  highlighSelectedRow(SelIndex) {

    this.angularGrid.gridService.highlightRow(this.g_previousIndex, 10);
    let that = this;
    this.angularGrid.gridService.highlightRow(SelIndex, 100000);
    setTimeout(function () {
      that.angularGrid.gridService.highlightRow(SelIndex, 100000);
    }, 300);

    this.g_previousIndex = SelIndex;
  }

  getTenantInfo() {
    this.spinner.show();
    let inpValue = new tenant();
    inpValue.languageUno = 1033;
    inpValue.itemUno = this.tenantUno;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;//this.RASHelper.encryptWithPublicKey('1');

    
    this.adminService.getTenants(inpValue)
      .subscribe(data => {
        
       
        let tenantData: any = data;
        if (tenantData != null && tenantData.length > 0) {
          this.isDivision = tenantData[0].isDivision;
          
        }
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
}


